import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AnnSearchFilterComponent } from './ann-search-filter/ann-search-filter.component';
import { AnnSearchComponent } from './ann-search/ann-search.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatRadioModule } from '@angular/material/radio';
import { MatInputModule, MatInput } from '@angular/material/input';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { AnnFilterSectionComponent } from './ann-filter-section/ann-filter-section.component';
import { AnnLocationFilterComponent } from './ann-location-filter/ann-location-filter.component';
import { AnnTypeFilterComponent } from './ann-type-filter/ann-type-filter.component';
import { AnnSalaryFilterComponent } from './ann-salary-filter/ann-salary-filter.component';
import { AnnPublishDateFilterComponent } from './ann-publish-date-filter/ann-publish-date-filter.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AnnPagingComponent } from './ann-paging/ann-paging.component';
import { AnnouncementItemComponent } from './announcement-item/announcement-item.component';
import { MainPageComponent } from './front-page/front-page.component';
import { CvBoxModule } from '../cv-box/cv-box.module';
import { SharedModule } from '../shared/shared.module';
import { AnnouncementRoutingModule } from './announcement-routing.module';
import { CustomerModule } from '../customer/customer.module';
import { SearchAndFilterComponent } from './search-and-filter/search-and-filter.component';

import { MatSelectModule } from '@angular/material/select';
import { AnnDetailsPageComponent } from './ann-details-page/ann-details-page.component';
import { SimilarAnnItemComponent } from './similar-ann-item/similar-ann-item.component';
import { AnnFavoritesComponent } from './ann-favorites/ann-favorites.component';
import { HrUiModule } from '../hr-ui/hr-ui.module';
import { UiModule } from '@hrra/ui';
import { BannerModule } from '../banner/banner.module';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { CommonComponentsModule } from '@hrra/common-components';
import { MatDialogModule } from '@angular/material/dialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { JobseekerModule } from '../jobseeker/jobseeker.module';

@NgModule({
  declarations: [
    SearchAndFilterComponent,
    AnnSearchFilterComponent,
    AnnSearchComponent,
    AnnFilterSectionComponent,
    AnnLocationFilterComponent,
    AnnTypeFilterComponent,
    AnnSalaryFilterComponent,
    AnnPublishDateFilterComponent,
    AnnPagingComponent,
    AnnouncementItemComponent,
    MainPageComponent,
    AnnDetailsPageComponent,
    SimilarAnnItemComponent,
    AnnFavoritesComponent,
  ],
  imports: [
    CommonModule,
    AnnouncementRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MultiSelectModule,
    CvBoxModule,
    SharedModule,
    MatExpansionModule,
    AngularSvgIconModule,
    MatCheckboxModule,
    MatRadioModule,
    MatDialogModule,
    MatFormFieldModule,
    MatInputModule,
    MatTooltipModule,
    MatSelectModule,
    JobseekerModule,
    HrUiModule,
    UiModule,
    BannerModule,
    InfiniteScrollModule,
    CarouselModule,
    CommonComponentsModule
  ],
  exports: [AnnSearchComponent, AnnouncementItemComponent],
})
export class AnnouncementModule {}
